import React from 'react';
import DataTable from '../../../../components/DataTable';
import Title from '../../../../components/Title';
import FilterBar from './FilterBar';

const uri = '/service/v1/health/network/list';

const initialParams = {
  sort: 'network|asc',
  // plan: 1,
  // plan_type: 1,
  // attention: 1,
};

const tableHeaders = [
  { name: 'network', label: 'Red' },
  { name: 'clinic', label: 'Clínica' },
  { name: 'amount', label: 'Copago' },
  { name: 'coverage', label: 'Cobertura' },
  { name: 'phone', label: 'Teléfono' },
  { name: 'address', label: 'Dirección' },
];

function Networks() {
  const [params, setParams] = React.useState(initialParams);

  function handleFilter(parms) {
    setParams({ ...initialParams, ...parms });
  }

  return (
    <>
      <Title variant="h5" component="h2">Redes de salud</Title>
      <DataTable
        uri={uri}
        params={params}
        headers={tableHeaders}
        filters={<FilterBar onFilter={handleFilter} />}
      />
    </>
  );
}

export default Networks;
